import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padding?: 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export function Card({ children, padding = 'md', className = '', ...props }: CardProps) {
  return (
    <div
      className={`bg-white rounded-[var(--radius-lg)] shadow-sm border border-slate-200
        dark:bg-slate-800 dark:border-slate-700
        ${paddingClasses[padding]} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}
